<template>
    <div class="signup-form">
        <div class="login-greeting">{{ $t('CREATE_ACCOUNT') }}</div>
        <div style="display: flex; max-width: 100%;">
            <LoginTextInput
                color="apple"
                :errors="errors"
                :label="$t('LABEL_FIRSTNAME')"
                icon="format_size"
                name="name"
                style="width: 40%;"
                :dark="true"
                v-model.trim="form.name"
            />
            <LoginTextInput
                color="apple"
                :errors="errors"
                :label="$t('LABEL_LASTNAME')"
                icon="format_size"
                name="surname"
                style="width: 56%; margin-left: 4%;"
                :dark="true"
                v-model.trim="form.surname"
            />
        </div>
        <transition name="fade">
            <LoginTextInput
                color="apple"
                :errors="errors"
                :label="$t('LABEL_SCHOOL_NAME')"
                icon="home"
                name="schoolName"
                v-if="formType == 'school'"
                :dark="true"
                v-model.trim="form.schoolName"
            />
        </transition>
        <LoginTextInput
            color="apple"
            :errors="errors"
            :label="$t('PLACEHOLDER_EMAIL')"
            icon="mail"
            :dark="true"
            name="mail"
            v-model.trim="form.mail"
        />
        <LoginTextInput
            color="apple"
            :errors="errors"
            :label="$t('PHONE')"
            icon="phone"
            name="phone"
            type="number"
            :dark="true"
            v-model.trim="form.phone"
        />
        <div style="display: flex; max-width: 100%;">
            <LoginTextInput
                color="apple"
                :errors="errors"
                :label="$t('LABEL_PASS')"
                icon="lock"
                name="password"
                style="width: 48%;"
                type="password"
                :dark="true"
                v-model.trim="form.password"
            />
            <LoginTextInput
                color="apple"
                :errors="errors"
                :label="$t('PLACEHOLDER_PASSWORD_CONFIRM')"
                icon="lock"
                name="repeatPassword"
                style="width: 48%; margin-left: 4%;"
                type="password"
                :dark="true"
                v-model.trim="form.repeatPassword"
            />
        </div>
        <div class="login-comment" style="margin-top: 1rem;">
            {{ $t('SIGNUP_REGULATIONS_TITLE') }}
        </div>
        <div class="login-checkbox">
            <CheckBox color="apple" v-model="form.regulations" />
            <div @click="goTo('regulations')" class="login-checkbox-text">
                {{ $t('READ_CONTENT_AND_ACCEPT_RULES') }}
            </div>
        </div>
        <div class="login-checkbox">
            <CheckBox color="apple" v-model="form.privacy" />
            <div @click="goTo('privacy')" class="login-checkbox-text">
                {{ $t('READ_CONTENT_AND_ACCEPT_PRIVACY') }}
            </div>
        </div>
        <ActionButton
            :label="$t('CREATE_ACCOUNT')"
            :loading="loading"
            @click="submit"
            color="apple"
            class="login-form-button"
        />
        <div class="login-actions-row" @click="goBack">
            <span class="login-action">{{ $t('CLOSE') }}</span>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            errors: new this.$Errors(),
            loading: false,
            form: {
                name: '',
                surname: '',
                mail: this.$route.query.mail ? this.$route.query.mail : '',
                phone: '',
                password: '',
                repeatPassword: '',
                regulations: false,
                privacy: false
            }
        }
    },
    computed: {
        region() {
            return this.$route.query.region
        },
        formType() {
            return this.$route.query.type
        }
    },
    methods: {
        capitalizeName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1)
        },
        cleanMail(mail) {
            return mail.replace(/\s+/g, '').toLowerCase()
        },
        cleanPhone(phone) {
            return phone.toString().replace(/\D/g, '')
        },
        goBack() {
            this.$emit('close')
        },
        closeMessage() {
            this.$store.commit('hideWarning')
            this.$emit('hideWarning')
        },
        submit() {
            if (this.loading) {
                return
            }
            this.errors.errors = []
            Object.keys(this.form).forEach(key => {
                if (this.form[key] === '') {
                    this.errors.set(key)
                }
            })
            if (this.errors.errors.length > 0) {
                return
            }
            const data = {
                name: this.capitalizeName(this.form.name),
                surname: this.capitalizeName(this.form.surname),
                mail: this.cleanMail(this.form.mail),
                password: this.form.password,
                phone: this.cleanPhone(this.form.phone),
                source: 'vod_web',
                language: 'pl'
            }
            this.loading = true
            this.$api
                .post(`v1/accounts`, data)
                .then(() => {
                    this.$store.commit('setWarning', {
                        title: this.$t('LABEL_SUCCESS'),
                        message: this.$t(
                            'TOAST_MESSAGE_SIGNUP_SUCCESS_MAIL_LEFT'
                        ),
                        acceptButton: '',
                        declineButton: '',
                        response: false,
                        type: 'info',
                        display: true,
                        accept: this.closeMessage,
                        decline: this.closeMessage
                    })
                    this.$emit('registered')
                })
                .catch(error => {
                    this.$Network.handleError(error, this.errors)
                })
                .then(() => {
                    this.loading = false
                })
        },
        goTo(site) {
            let url = ''
            if (site == 'regulations') {
                switch (this.region) {
                    case 'de':
                        url = `https://livekid.com/de/allgemeine-geschaeftsbedingungen`
                        break
                    case 'ch':
                        url = `https://livekid.com/de-ch/allgemeine-geschaeftsbedingungen/`
                        break
                    default:
                        url = `https://livekid.com/pl/regulamin-dla-placowki/?_ga=2.25252414.203701643.1577949072-576133507.1560934293`
                        break
                }
            } else {
                switch (this.region) {
                    case 'de':
                        url = `https://livekid.com/de/datenschutz`
                        break
                    case 'ch':
                        url = `https://livekid.com/de-ch/datenschutz`
                        break
                    default:
                        url = `https://livekid.com/pl/polityka-prywatnosci/?_ga=2.63151276.203701643.1577949072-576133507.1560934293`
                        break
                }
            }
            window.open(url, '_blank')
        }
    }
}
</script>
<style lang="scss" scoped>
.signup-form {
    display: flex;
    flex-direction: column;
    width: 100%;
    z-index: 100;
    min-width: 250px;
}
.login-action {
    color: $accent-apple !important;
}
</style>
